module.exports = __webpack_public_path__ + "static/img/s_7.69b5623a.png";